import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import SendPage from "../pages/send/page";
import HistoryPage from "../pages/history/page";
import ContactsPage from "../pages/contacts/page";
import SettingsPage from "../pages/settings/page";
import SchedulePage from "../pages/schedule/page";
import CarrierTestPage from "../pages/carrier-test/page";
import AdminPage from "../pages/admin/page";
import StatsPage from "../pages/stats/page";
import SupportPage from "../pages/support/page";
import AgencyPage from "../pages/agency/page";
import DeletionLogsPage from "../pages/deletion-logs/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/dashboard/send",
    element: <SendPage />,
  },
  {
    path: "/dashboard/history",
    element: <HistoryPage />,
  },
  {
    path: "/dashboard/contacts",
    element: <ContactsPage />,
  },
  {
    path: "/dashboard/settings",
    element: <SettingsPage />,
  },
  {
    path: "/dashboard/schedule",
    element: <SchedulePage />,
  },
  {
    path: "/dashboard/carrier-test",
    element: <CarrierTestPage />,
  },
  {
    path: "/dashboard/stats",
    element: <StatsPage />,
  },
  {
    path: "/dashboard/deletion-logs",
    element: <DeletionLogsPage />,
  },
  {
    path: "/dashboard/support",
    element: <SupportPage />,
  },
  {
    path: "/agency",
    element: <AgencyPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/users",
    element: <AdminPage />,
  },
  {
    path: "/admin/charges",
    element: <AdminPage />,
  },
  {
    path: "/admin/notices",
    element: <AdminPage />,
  },
  {
    path: "/admin/sender-review",
    element: <AdminPage />,
  },
  {
    path: "/admin/send-stats",
    element: <AdminPage />,
  },
  {
    path: "/admin/api-keys",
    element: <AdminPage />,
  },
  {
    path: "/admin/carrier-numbers",
    element: <AdminPage />,
  },
  {
    path: "/admin/carrier-test-review",
    element: <AdminPage />,
  },
  {
    path: "/admin/system",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;